import type { ActiveTableState } from './types';

export const reducers = {
  setActiveTablesCount: (state: ActiveTableState, payload = 0): ActiveTableState => ({
    ...state,
    activeTablesCount: payload
  })
};
